import axios from 'axios';

// 使用相对路径，通过Nginx代理访问后端API
const API_BASE_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_API_BASE_URL || '';

class FeedbackAdminAPI {
  constructor() {
    this.api = axios.create({
      baseURL: `${API_BASE_URL}/api/v1/admin`,
      timeout: 10000,
    });

    // 添加请求拦截器，自动添加管理员认证token
    this.api.interceptors.request.use(
      (config) => {
        const adminToken = localStorage.getItem('admin_token');
        const adminUser = localStorage.getItem('admin_user');
        
        if (adminToken && adminUser) {
          try {
            const adminUserData = JSON.parse(adminUser);
            config.headers.Authorization = `Bearer ${adminToken}`;
            if (adminUserData.id) {
              config.headers['X-User-ID'] = adminUserData.id.toString();
            }
          } catch (error) {
          }
        }
        
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    // 添加响应拦截器，处理错误
    this.api.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response?.status === 401) {
          localStorage.removeItem('admin_token');
          localStorage.removeItem('admin_user');
          setTimeout(() => {
            window.location.href = '/sys-portal/login';
          }, 0);
        }
        return Promise.reject(error);
      }
    );
  }

  // 获取反馈列表
  async getFeedbacks(page = 1, pageSize = 20, scoreRange = null) {
    try {
      const params = {
        page,
        page_size: pageSize
      };
      if (scoreRange) {
        params.score_range = scoreRange;
      }
      
      const response = await this.api.get('/feedbacks', { params });
      if (response.data.success) {
        return response.data.data;
      }
      throw new Error(response.data.detail || '获取反馈列表失败');
    } catch (error) {
      throw error;
    }
  }

  async getFeedbackStats() {
    try {
      const response = await this.api.get('/feedbacks/stats');
      if (response.data.success) {
        return response.data.data;
      }
      throw new Error(response.data.detail || '获取反馈统计失败');
    } catch (error) {
      throw error;
    }
  }

  async getFeedbackDetail(feedbackId) {
    try {
      const response = await this.api.get(`/feedbacks/${feedbackId}`);
      if (response.data.success) {
        return response.data.data;
      }
      throw new Error(response.data.detail || '获取反馈详情失败');
    } catch (error) {
      throw error;
    }
  }
}

const feedbackAdminAPI = new FeedbackAdminAPI();
export default feedbackAdminAPI;

